import AnyAction from 'store/anyActions';
import InternalMessagingState from './internal-messaging.state';
import InternalMessagingTypes from './internal-messaging.types';

const defaultState = {
    selectedConversationId: undefined,
    phoneBookOpen: false
}

export default function (state: InternalMessagingState = defaultState, action: AnyAction): InternalMessagingState | null {
    switch (action.type) {
        case InternalMessagingTypes.SELECT_CONVERSATION:
            return {
                ...state,
                selectedConversationId: action.payload.id
            };
        case InternalMessagingTypes.OPEN_PHONEBOOK:
            return {
                ...state,
                phoneBookOpen: action.payload
            };
        default:
            return state;
    }
}
